import Select from "../../../../form/Select";
import React from "react";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems} = props;
    return (hidden || []).indexOf("pos") === -1 && <Select
        label={labels.pos || "Eladás helye"}
        name="pos"
        component="PointOfSale"
        objectValue={true}
        labelKey="name"
        storeType="local"
        {...props.getProps("pos")}
        value={props.getValue("pos")}
        saveChanges={props.setFieldValue}
    />;
}